import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const CreditStatus = Loadable(() => import('../../containers/web/index'));
export default MapTo('vcg/components/soe-home/react/creditPage')(CreditStatus);
